/**
 * Structural publish-state signal for raw fetch() writes (plan 2 D11).
 *
 * The server's PublishStateChangedMiddleware adds this event to the
 * HX-Trigger header of every successful mutation under a website or property
 * route, and htmx dispatches it for htmx-issued requests. A raw fetch() never
 * processes HX-Trigger, so a fetch-driven write (CMS autosave, picker saves,
 * uploads) calls signalPublishStateChanged() after a confirmed 2xx instead.
 * Listeners (header Publish button, build chip, CMS editor) debounce it and
 * re-read GET {base}/api/publish-state — the event carries no state itself.
 * Name mirrors HXEventWebsitePublishStateChanged in internal/api/hx_events.go.
 */
export const PUBLISH_STATE_CHANGED_EVENT = "website-publish-state-changed";

export function signalPublishStateChanged(): void {
  // Advisory signal: never let it fail the write path that called it.
  if (typeof document === "undefined") return;
  document.body?.dispatchEvent(new CustomEvent(PUBLISH_STATE_CHANGED_EVENT, { bubbles: true }));
}
